import { NoraTextAreaInput } from 'ethos-design-system';
import React, { useContext, useEffect, useState } from 'react';

import { FlexGrid, FlexRow, Spacer } from '../../../../../common/components/v2';

import { Reason } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { FeatureFlagsContext } from '../../../../../common/featureFlagsWrapper';
import { Eti } from '../../../../tasks/types/eti';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import { RequiredFieldTitle } from '../../RequiredFieldTitle';
import styles from '../../styles.module.scss';

export const ETILayout = ({
  eti,
  setEti,
  isExpanded,
  reasons,
  etiError,
}: {
  eti: Eti;
  setEti: React.Dispatch<React.SetStateAction<Eti>>;
  isExpanded: boolean;
  reasons: Reason[];
  etiError: boolean;
}) => {
  const { flags } = useContext(FeatureFlagsContext);
  const { uwNativeEtiEnabled } = flags;

  const [question, setQuestion] = useState(eti.question || '');
  const [reasonDescription, setReasonDescription] = useState(
    eti.reasonDescription || '',
  );
  const [selectedReasons, setSelectedReasons] = useState(
    eti.reason || ([] as string[]),
  );

  useEffect(() => {
    const newEti = {} as Eti;
    if (isExpanded) {
      newEti.question = question;
      newEti.reason = selectedReasons;
      newEti.reasonDescription = reasonDescription;
    } else {
      setQuestion('');
      setReasonDescription('');
      setSelectedReasons([] as string[]);
    }
    setEti(newEti);
  }, [isExpanded, reasonDescription, question, selectedReasons.length]);

  return (
    <FlexGrid>
      {etiError && (
        <>
          <RequiredFieldErrorBar />
          <Spacer height={8} />
        </>
      )}
      {!uwNativeEtiEnabled && (
        <FlexRow>
          <RequiredFieldTitle title={Resource.QUESTIONS_HEADER} />
          <NoraTextAreaInput
            name="eti-questions"
            data-tid="eti-questions-textarea"
            textClassName={styles.TextareaInput}
            onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
              setQuestion(ev.currentTarget.value);
            }}
            value={question}
          />
        </FlexRow>
      )}
      <FlexRow>
        <RequiredFieldTitle title={Resource.ORDER_REASON} />
        <ReasonsChoicePanel
          reasons={reasons}
          selectedReasons={selectedReasons}
          selectReasonsCallback={setSelectedReasons}
        />
        <NoraTextAreaInput
          name="eti-reason"
          data-tid="eti-reason-textarea"
          placeholder="Describe the reason"
          textClassName={styles.TextareaInput}
          onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
            setReasonDescription(ev.currentTarget.value);
          }}
          value={reasonDescription}
        />
      </FlexRow>
    </FlexGrid>
  );
};
